import { googleAnalyticsParams } from "./googleAnalytics";
export default function getGoogleAnalyticsParams() {
    var _a, _b, _c;
    const params = googleAnalyticsParams();
    if (!params) {
        return {};
    }
    const code = (_c = (_b = (_a = ga.getAll()[0]) === null || _a === void 0 ? void 0 : _a.b) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.values[':trackingId'];
    let clientID = "", userID = "";
    for (const param of params) {
        if (param && param.get && param.get('trackingId') === code) {
            clientID = param.get('clientId');
            userID = param.get("userId");
        }
    }
    if (clientID && userID) {
        return {
            clientID,
            userID,
            cid: (window.__st && window.__st.cid) ? window.__st.cid : undefined
        };
    }
    return {};
}
//# sourceMappingURL=getGoogleAnalyticsParams.js.map